module.exports = __webpack_public_path__ + "static/img/waste-utilization.b4412f48.png";